module.exports = __webpack_public_path__ + "static/img/19.b86b9f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/19.png
// module id = HMjO
// module chunks = 0